// @owners { team: patients-team }
import { Description, ListItem } from '@alto/design-system';
import { NO_KNOWN_ALLERGIES } from '@alto/features';
import React from 'react';
import { type User } from '~shared/types';

type Props = {
  user: User;
};

export const MedicalInfo = ({ user }: Props) => {
  const { allergens = [], allergies, medical_conditions } = user;
  const formattedAllergies = allergens.map((allergen) => allergen.description);
  if (allergies && allergies !== NO_KNOWN_ALLERGIES) {
    allergies.split(',').forEach((allergy) => {
      formattedAllergies.push(allergy);
    });
  }

  return (
    <>
      <ListItem
        title="Allergies"
        descriptions={<Description>{formattedAllergies.join(', ') || 'No allergies on file'}</Description>}
      />
      <ListItem
        title="Medical conditions"
        descriptions={<Description>{medical_conditions || 'No medical conditions on file'}</Description>}
      />
    </>
  );
};
